import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import messages from './messages';

interface INotificationModalProps {
  statusMessages: string[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  messagesValues?: any;
}

export const NotificationModal: React.FC<INotificationModalProps> = ({
  statusMessages,
  messagesValues,
}) => {
  if (!statusMessages) {
    return null;
  }

  return (
    <div>
      {statusMessages.map((messageKey) => (
        <div key={messageKey}>
          <FormattedMessage
            {...messages[messageKey]}
            values={{
              ...messagesValues,
              b: (chunks) => <b>{chunks}</b>,
            }}
          />
        </div>
      ))}
    </div>
  );
};
